import { Paper, Stack, Typography } from '@mui/material';
import * as React from 'react';

interface Props {
	title: string;
	count: number;
	width?: number;
}

export default function IntegrationSummary({ title, count, width }: Props) {
	return (
		<Paper
			sx={{
				borderRadius: 2,
				mt: 2,
				p: 2,
				width: width || '100%',
			}}
		>
			<Stack>
				<Typography variant='bodySemiBold'>{title}</Typography>
				<Typography>{count}</Typography>
			</Stack>
		</Paper>
	);
}
2;
